import { InvalidUrlError } from '@execonline-inc/url';
import { Maybe, nothing } from 'maybeasy';
import { AppyError } from '../../../../../../../Appy';
import { MissingLinkError } from '../../../../../../../LinkyLinky';
import { Resource } from '../../../../../../../Resource/Types';
import { TPlainTextKey } from '../../../../../../../Translations';
import { GroupMember } from '../../../Stores/ShareStore/Types';

export interface Waiting {
  kind: 'waiting';
}

export interface User {
  id: number;
  firstName: string;
  lastName: string;
  email: string;
  licenseCount: number;
  learningCollectionCount: number;
  lastLogin: Maybe<Date>;
}

export interface UserGroup {
  id: number;
  name: string;
  members: ReadonlyArray<GroupMember>;
}

export interface ParticipantsPayload {
  participants: User[];
}

export interface UserGroupsPayload {
  userGroups: UserGroup[];
}

export type ParticipantsResource = Resource<ParticipantsPayload>;
export type UserGroupsResource = Resource<UserGroupsPayload>;

export type TabType = 'participants' | 'groups';

export interface Ready {
  kind: 'ready';
  participantNameSearch: string;
  groupNameSearch: string;
  selectedLicenseId: Maybe<string>;
  users: User[];
  groups: UserGroup[];
  selectedUserIds: Set<number>;
  selectedGroupIds: Set<number>;
  selectedUsers: Map<number, User>;
  selectedGroups: Map<number, UserGroup>;
  activeTab: TabType;
}

export interface Error {
  kind: 'error';
  message: TPlainTextKey;
}

export type ParticipantSearchState = Waiting | Ready | Error;

export const waiting = (): Waiting => ({
  kind: 'waiting',
});

export const ready = (): Ready => ({
  kind: 'ready',
  participantNameSearch: '',
  groupNameSearch: '',
  selectedLicenseId: nothing(),
  users: [],
  groups: [],
  selectedUserIds: new Set(),
  selectedGroupIds: new Set(),
  selectedUsers: new Map(),
  selectedGroups: new Map(),
  activeTab: 'participants',
});

export const error = (message: TPlainTextKey): Error => ({
  kind: 'error',
  message,
});

export type ParticipantSearchError = MissingLinkError | AppyError | InvalidUrlError;
